import { createSelector } from '@reduxjs/toolkit';
// @ts-expect-error Untyped import
import { getThreadByThreadId } from './getThreadByThreadId';
import { getCurrentUrl } from '../operators/getCurrentUrl';
export const getCurrentUrlByThreadId = createSelector([getThreadByThreadId], getCurrentUrl);